import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import stripePromise from "../../stripe";

const StripeWrapper = ({ children }) => {
  return <Elements stripe={stripePromise}>{children}</Elements>;
};

export default StripeWrapper;
